import React from "react";
import ItemsHorizontalScroll from "../../shared/itemsHorizontalScroll/itemsHorizontalScroll";
import ItemTmdbBtnV2 from "../../../shared/itemTmdbBtnV2/itemTmdbBtnV2";
import UseSquadflixNavigate from "../useSquadflixNavigate";
import SquadflixRowTitle from "../squadflixRowTitle/squadflixRowTitle";
import {useTrendingSeriesData} from "../../hooks/useCatalogRowData";

type Props = SquadflixRowsBaseProps & {
    onSerieClick?: (item: any) => void;
}

const TrendingSeriesRow = (props: Props) => {
    const {onSerieClick} = props;
    const {series: tmdbTrendingSeries, loading} = useTrendingSeriesData();
    const squadflixNav = UseSquadflixNavigate({});

    if (loading) return null;
    if (!tmdbTrendingSeries || tmdbTrendingSeries.length === 0) return null;
    return (
        <div style={{height: "275px", overflow: "hidden", order: props.order ?? 0}}>
            <SquadflixRowTitle
                {...props}
                title="Tendencias: Series"
                icon={<i className="fa-solid fa-chart-simple"></i>}
            />
            <ItemsHorizontalScroll>
                {tmdbTrendingSeries.map((item) => (
                    <ItemTmdbBtnV2
                        key={item.id}
                        onClick={() => onSerieClick ? onSerieClick(item) : squadflixNav.navigateToSerie(item)}
                        bottomInfo={<>{item.vote_average.toFixed(1)}<i
                            className="fa-solid fa-star text-warning fa-sm ps-1"></i></>}
                        tmdbItem={item}
                        type="tv"
                        description={item.first_air_date}
                    />
                ))}
            </ItemsHorizontalScroll>
        </div>
    );
};

export default TrendingSeriesRow;
